import { render, staticRenderFns } from "./RaceStatus.vue?vue&type=template&id=3643ffba&scoped=true&"
import script from "./RaceStatus.vue?vue&type=script&lang=js&"
export * from "./RaceStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3643ffba",
  null
  
)

export default component.exports